import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { cloneDeep, isEqual } from 'lodash';
import { EncountersState, preventionTypes } from '../encounter-prevention-dialog.component';
import { ExclusionGroup } from '../../../../models/ExclusionGroup';
import { DropdownOptions } from 'app/core/components/dropdown-selection/dropdown-selection.component';
import { FeatureFlagService, FLAGS } from 'app/services/feature-flag.service';
import { map, Observable, startWith, Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'app-create-group',
	templateUrl: './create-group.component.html',
	styleUrls: ['./create-group.component.scss'],
})
export class CreateGroupComponent implements OnInit, OnDestroy {
	form!: UntypedFormGroup;
	@Input() state!: EncountersState;

	@Output() update: EventEmitter<any> = new EventEmitter<any>();

	isEdit!: boolean;
	group!: ExclusionGroup;
	groupInitialState: any;
	showSaveButton!: boolean;

	preventionGroupOptions = preventionTypes;
	preventionType$!: Observable<string>;

	activityEPFF = this.featureFlagService.isFeatureEnabledV2(FLAGS.ActivityEncounterPreventionFF);

	private destroy$: Subject<void> = new Subject<void>();

	constructor(private featureFlagService: FeatureFlagService) {}

	ngOnInit(): void {
		this.isEdit = !!this.state.data.currentGroup;
		this.group = this.getSafeGroup(this.isEdit ? this.state.data.currentGroup : this.state.createGroup);

		this.form = new UntypedFormGroup({
			name: new UntypedFormControl(this.group.name),
			notes: new UntypedFormControl(this.group.notes),
			prevention_type: new UntypedFormControl(this.group.prevention_type || 'passes_and_activities'),
		});

		const preventionControl = this.form.get('prevention_type') as FormControl;
		this.preventionType$ = preventionControl.valueChanges.pipe(
			startWith(preventionControl.value),
			map((value) => value as string)
		);

		this.groupInitialState = cloneDeep(this.group);

		this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
			this.group = { ...this.group, ...value };
			this.onUpdate();
		});
	}

	private getSafeGroup(group: ExclusionGroup | undefined): ExclusionGroup {
		return (
			group ?? {
				name: '',
				notes: '',
				prevented_encounters: [],
				encounter_count: 0,
				override_count: 0,
				users: [],
				issuer: '',
				prevention_type: 'passes_and_activities',
			}
		);
	}

	getPreventionOption(value: string): DropdownOptions<string> | null {
		return this.preventionGroupOptions.find((opt) => opt.value === value) ?? null;
	}

	handleselectedPreventionType(selected: DropdownOptions<string>): void {
		this.form.get('prevention_type')?.setValue(selected.value);
	}

	onUpdate() {
		this.showSaveButton = !isEqual(this.groupInitialState, this.group) || !this.isEdit;
		if (this.isEdit) {
			this.state.data.currentGroup = this.group;
		} else {
			this.state.createGroup = this.group;
		}
		this.update.emit({ ...this.state, data: { ...this.state.data, ...this.form.value, showSaveButton: this.showSaveButton } });
	}

	ngOnDestroy(): void {
		this.destroy$.next(undefined);
		this.destroy$.complete();
	}
}
